import React, { useState, useEffect, useContext } from "react";
import Modaleditqueue from "./../queue/modaleditqueue";
import Modalchip from "./../queue/modalchip";
import ModalAskConfrim from "../common/confirmSubmit";
import { queuelist1, queuelist2 } from "./datalist";
import { getQueue } from "../../services/wms";

import { toast } from "react-toastify";

const Editqueue = () => {
  const [isopenAsk, setisopenAsk] = useState(false);
  const [isOpen, setisOpen] = useState(false);
  const [chip, setchip] = useState(false);
  const [plam, setplam] = useState(false);
  const [store, setstore] = useState(false);
  const [other, setother] = useState(false);
  const [chipper, setchipper] = useState(false);
  const [datalist, setdatalist] = useState([]);
  const [dataid, setdataid] = useState([]);

  const onConfirm = (data, id) => {
    //console.log("aaaa", id)
    if (id === 1) {
      setisOpen(false);
      toast.success("บันทึกเสร็จเรียบร้อย");
    } else if (id === 2) {
      setchip(false);
      toast.success("บันทึกเสร็จเรียบร้อย");
    } else if (id === 3) {
      setplam(false);
      toast.success("บันทึกเสร็จเรียบร้อย");
    } else if (id === 4) {
      setstore(false);
      toast.success("บันทึกเสร็จเรียบร้อย");
    } else if (id === 5) {
      toast.success("บันทึกเสร็จเรียบร้อย");
      setchipper(false);
    } else if (id === 6) {
      toast.success("บันทึกเสร็จเรียบร้อย");
      setother(false);
    }
  };

  useEffect(() => {
    const loadRegister = async () => {
      const { data: result } = await getQueue();
      if (result) {
        setdatalist(result);
      } else {
        toast.error(result.message);
      }
    };
    loadRegister();
  }, []);

  const handleonClick = (id) => {
    setdataid(id);
    if (id === 1) {
      setisOpen(true);
    } else if (id === 2) {
      setchip(true);
    } else if (id === 3) {
      setplam(true);
    } else if (id === 4) {
      setstore(true);
    } else if (id === 5) {
      setchipper(true);
    } else if (id === 6) {
      setother(true);
    }
  };

  const handleonCancel = () => {
    setisOpen(false);
  };

  const onCancel = (id) => {
    if (id === 1) {
      setisOpen(false);
    } else if (id === 2) {
      setchip(false);
    } else if (id === 3) {
      setplam(false);
    } else if (id === 4) {
      setstore(false);
    } else if (id === 5) {
      setchipper(false);
    } else if (id === 6) {
      setother(false);
    }
  };
  const onAskConfirm = () => {
    setisopenAsk(true);
  };
  const onCancelSave = () => {
    setisopenAsk(false);
  };
  //console.log("data", datalist);
  return (
    <div className="container  d-flex justify-content-center">
      <ModalAskConfrim
        isOpen={isopenAsk}
        button1={"บันทึก"}
        onCancel={onCancelSave}
      />
      <Modaleditqueue
        isOpen={isOpen}
        onConfirm={onConfirm}
        onCancel={onCancel}
        id={dataid}
      />
      <Modalchip
        isOpen={chip}
        id="chip"
        onConfirm={onConfirm}
        onCancel={onCancel}
        header="แก้ไขจำนวนรถ ไม้ชิพรถกล่อง AA"
        label="ไม้ชิพรถกล่อง AA"
        limit="  Limit ( 4 คัน / ชม. )"
        id={dataid}
      />
      <Modalchip
        isOpen={plam}
        onCancel={onCancel}
        id="plam"
        onConfirm={onConfirm}
        header="แก้ไขจำนวนรถ กะลาปาล์ม"
        label="กะลาปาล์ม"
        limit="  Limit ( 4 คัน / ชม. )"
        id={dataid}
      />
      <Modalchip
        isOpen={store}
        id="store"
        onConfirm={onConfirm}
        onCancel={onCancel}
        header="แก้ไขจำนวนรถ ลานโกดัง"
        label="ลานโกดัง"
        limit="  Limit ( 8 คัน / ชม. )"
        id={dataid}
      />
      <Modalchip
        isOpen={other}
        onCancel={onCancel}
        id="other"
        onConfirm={onConfirm}
        header="แก้ไขจำนวนรถ อื่นๆ"
        label="อื่น ๆ"
        limit="  Limit ( 15 คัน / ชม. )"
        id={dataid}
      />
      <Modalchip
        isOpen={chipper}
        onCancel={onCancel}
        id="other"
        onConfirm={onConfirm}
        header="แก้ไขจำนวนรถ Chipper"
        label="อื่น ๆ"
        limit="  Limit ( 10 คัน / ชม. )"
        id={dataid}
      />

      <div className="col-lg-10  mt-2 ">
        <div className="row ">
          <p className="badge rounded-pill text-primary mt-2 mb-2 fs-1 ">
            <i
              className=" bi bi-check-circle-fill  text-primary me-2"
              style={{ fontSize: "25px" }}
            ></i>
            กำหนดปริมาณรถเข้าโรงงาน
          </p>
        </div>

        <div className="row ms-4 ">
          <div className="col-lg-12 ">
            <div className="shadow border-top ">
              <div className="card-body ">
                <span
                  className="badge bg-info text-dark mb-2 text-center d-flex justify-content-center  "
                  style={{ fontSize: "15px" }}
                >
                  <i className="bi bi-stack me-2"></i>
                  ข้อมูลจำนวนรถ 16 เที่ยว/ชม.
                </span>

                {datalist &&
                  datalist.length > 0 &&
                  datalist.map((item, index) => (
                    <div className="col-lg-12" key={index}>
                      <div className="card mb-1">
                        <div className="card-body p-1">
                          <div className="row align-items-center justify-content-between">
                            <div className="col-lg-4  ">
                              <h6 className="d-inline font-weight-bold">
                                <i className="bi bi-border-width  text-primary me-2"></i>
                                {item.name}
                              </h6>
                            </div>
                            <div className="col-lg-3 ">
                              <div className="row">
                                <div className="col-auto">
                                  <span className="badge rounded-pill bg-success text-start">
                                    {/* {item.cust_perHr} */}6
                                  </span>
                                  <span className="text-dark ms-2">
                                    รถบริษัท
                                  </span>
                                </div>
                                <div className="col-auto">
                                  <span className="badge rounded-pill bg-warning text-start text-dark">
                                    {/* {item.cust_perHr} */}5
                                  </span>
                                  <span className="text-dark ms-2">
                                    รถลูกค้า
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4  ">
                              <span className="badge rounded-pill bg-primary text-start">
                                {item.cust_perHr}
                              </span>
                              <span className="text-dark ms-2">คัน/ชม.</span>
                              <span
                                className="text-danger ms-2 text-start"
                                style={{ fontSize: "14px" }}
                              >
                                Limit ({item.queumax} คัน/ชม.)
                              </span>
                            </div>

                            <div className="col-lg-1 text-end">
                              <i
                                onClick={() => handleonClick(item._id)}
                                className="bi bi-pencil-square me-2 text-info"
                                style={{ fontSize: "23px", cursor: "pointer" }}
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editqueue;
